import { render, staticRenderFns } from "./CandidateForm.vue?vue&type=template&id=aaf26462"
import script from "./CandidateForm.vue?vue&type=script&lang=js"
export * from "./CandidateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports